import React from 'react'

export default function TpvNCScoreHeader({title, NCScoreCellColor}) {
    return (
        <>
            <h3
                style={{
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                }}
            >
                <span
                    style={{
                        display: 'inline-block',
                        borderBottom: '2px solid black',
                        paddingBottom: '4px',
                    }}
                >
                    {title}
                </span>
            </h3>
            <div style={{ display: 'flex', gap: '2rem'  }}>
                <div>
                    <p style={{ display: 'inline-block', fontWeight: 'bold' }}> Open:</p> &nbsp;
                    <div style={{ display: 'inline-block' }}>
                        <div className='rectangle' style={{ backgroundColor: NCScoreCellColor.open_low}}></div>
                        &nbsp;
                        <p style={{ display: 'inline-block' }}> Low</p> &nbsp;
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <div className='rectangle' style={{ backgroundColor: NCScoreCellColor.open_medium }}></div>
                        &nbsp;
                        <p style={{ display: 'inline-block' }}> Medium</p> &nbsp;
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <div className='rectangle' style={{ backgroundColor: NCScoreCellColor.open_high }}></div>
                        &nbsp;
                        <p style={{ display: 'inline-block' }}> High</p> &nbsp;
                    </div>
                </div>
                <div>
                    <p style={{ display: 'inline-block', fontWeight: 'bold' }}> Closed:</p> &nbsp;
                    <div style={{ display: 'inline-block' }}>
                        <div className='rectangle' style={{ backgroundColor: NCScoreCellColor.close_low }}></div>
                        &nbsp;
                        <p style={{ display: 'inline-block' }}> Low</p> &nbsp;
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <div className='rectangle' style={{ backgroundColor: NCScoreCellColor.close_medium }}></div>
                        &nbsp;
                        <p style={{ display: 'inline-block' }}> Medium</p> &nbsp;
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <div className='rectangle' style={{ backgroundColor: NCScoreCellColor.close_high }}></div>
                        &nbsp;
                        <p style={{ display: 'inline-block' }}> High</p> &nbsp;
                    </div>
                </div>
            </div>
        </>
    )
}
